module.exports = __webpack_public_path__ + "img/clock-rotate-left.97492cc7.svg";